export default __webpack_public_path__ + "1495f578452eb676f730244d3b9368cd.ttf";